import { jsx as _jsx } from "react/jsx-runtime";
import { CatList } from "blocks-nextjs/blocks-react/components/List/List";
import { CatListItem } from "blocks-nextjs/blocks-react/components/ListItem/ListItem";
import { CatSearchForm } from "blocks-nextjs/blocks-react/components/SearchForm/SearchForm";
import React, { useRef, useState } from "react";
import useAppConfigStore from "../../store/useAppConfigStore";
const CustomerSearch = ({ partyNumber, setPartyNumber, size }) => {
    const { appConfig } = useAppConfigStore((state) => ({
        appConfig: state.appConfig
    }));
    const dataLayer = (window["dataLayer"] = window["dataLayer"] || []);
    //using ref  here to  stop the formStart event from being triggered multiple times
    const isFormStartTriggered = useRef(false);
    const showCustomerList = (() => {
        const baseCustomers = [
            "Van Oord (2970049177)",
            "Test Customer (2969966437)",
            "BioIn GmbH (2969993529)",
            "Peterborough (2969600765)",
            "Gradex Inc (2969473818)",
            "Holder Construction Group LLC (2976038276)",
            "Google Inc (2975294033)"
        ];
        if (appConfig?.release_1_1?.showMalagaProject) {
            baseCustomers.push("Malaga (2969944796)");
        }
        if (appConfig?.release_1_1?.showMalagaDemonstrationCenter) {
            baseCustomers.push("MALAGA DEMONSTRATION & LEARNING CENTER (2972084572)");
        }
        return baseCustomers;
    })(); //This needs to be replaced with API once it is available
    const [searchedResults, setSearchedResults] = useState(showCustomerList);
    const triggerFormStartEvent = () => {
        if (!isFormStartTriggered.current) {
            dataLayer.push({
                event: "formStart",
                formDestination: window.location.href,
                formId: "select projects",
                formLength: 1,
                formName: "select projects"
            });
        }
        isFormStartTriggered.current = true;
    };
    function handleCustomerSearch(event) {
        triggerFormStartEvent();
        const searchCustomerValue = event.detail.value?.toLowerCase() || "";
        if (searchCustomerValue) {
            const filteredResults = showCustomerList.filter((item) => item.toLowerCase().includes(searchCustomerValue));
            setPartyNumber(searchCustomerValue);
            setSearchedResults(filteredResults);
        }
        else {
            setPartyNumber("");
            setSearchedResults(showCustomerList);
        }
    }
    const handleSelectedItem = (event) => {
        triggerFormStartEvent();
        setPartyNumber(event.detail.value);
    };
    return (_jsx("div", { "data-test": "customer-selection-modal", children: _jsx(CatSearchForm, { "data-test": "customer-search-form", hideSearchIcon: false, label: "list item group", onBlChange: handleCustomerSearch, onBlSelect: handleSelectedItem, openOnClick: true, placeholder: "Search Customer", size: size, value: partyNumber, children: _jsx(React.Fragment, { children: _jsx(CatList, { spacing: "padded", children: searchedResults.map((result, index) => (_jsx(CatListItem, { "data-test": "customer-selection-list-item", onBlSelect: handleSelectedItem, value: result }, index))) }) }, ".0") }) }));
};
export default CustomerSearch;
